import { ReactElement, ReactNode } from "react"
import { useParams } from "react-router-dom"

import AmendEVDCDeviceProvider from "./baseProviders/amendEVDCDeviceProvider"
import useContinueEVDCDeviceDraft from "../../../../../services/middleware/hooks/devices/lct/useContinueEVDCDeviceDraft"

interface IContinueEVDCDeviceAmendmentUrlParams {
    deviceRef: string
}

interface IContinueEVDCDeviceAmendmentProviderProps {
    children: ReactNode
}

const ContinueEVDCDeviceAmendmentProvider = ({
    children,
}: IContinueEVDCDeviceAmendmentProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof IContinueEVDCDeviceAmendmentUrlParams
    >() as IContinueEVDCDeviceAmendmentUrlParams

    const {
        data: formData,
        setData: setFormData,
        isLoading,
        error: continueAmendmentError,
        attachmentUUID,
        apiResSystemRef,
    } = useContinueEVDCDeviceDraft(urlDeviceRef)

    return (
        <AmendEVDCDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={isLoading}
            formDataError={continueAmendmentError}
            attachmentUUID={attachmentUUID ?? undefined}
            systemReference={apiResSystemRef ?? "Not loaded"}
        >
            {children}
        </AmendEVDCDeviceProvider>
    )
}

export default ContinueEVDCDeviceAmendmentProvider
